import axios, { AxiosResponse } from "axios";

const API_URL = process.env.REACT_APP_API_URL;


class AccountTransactions {
  create = async (transaction: any) => {
    const res = await axios.post<any>(`${API_URL}account-transaction`, transaction)
      .catch((e) => {
        const { message } = e.response.data;
        if (message.errorInfo) throw message.errorInfo[2];
        else throw e.message;
      });
    return res?.data.accTransaction;
  };

    reversal = async (code: any) => {
    await axios.post<any>(`${API_URL}acc-transaction-reversal`, code)
      .catch((e) => {
        const { message } = e.response.data;
        if (message.errorInfo) throw message.errorInfo[2];
        else throw e.message;
      });
  };



  edit = async (transaction: any, code: any) => {
    await axios.put<any>(`${API_URL}account-transaction/${code}`, transaction)
      .catch((e) => {
        const { message } = e.response.data;
        if (message.errorInfo) throw message.errorInfo[2];
        else throw e.message;
      });
  };

  get = async (code: any) => {
    const response = await axios.get<any>(`${API_URL}account-transaction/${code}`)
      .catch((e) => {
        throw e.message;
      });
    return response.data.accTransaction;
  };

  getAll = async () => {
    const response = await axios.get<any>(`${API_URL}account-transaction`)
      .catch((e) => {
        throw e.message;
      });
    return response.data.accTransaction;
  };

  getAllTransactionType = async () => {
    const response = await axios.get<any>(`${API_URL}account-transaction-type`)
      .catch((e) => {
        throw e.message;
      });
    return response.data.accTransactionType;
  };
}

export default new AccountTransactions();
